import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

// Controls based on orbit controls
export default class Controls {
	constructor(camera, container) {
		this.orbitControls = new OrbitControls(camera, container);
		this.init();
	}

	init() {
		this.orbitControls.enabled = true;
		this.orbitControls.target.set(0, 0, 0);
		this.orbitControls.autoRotate = false;
		this.orbitControls.autoRotateSpeed = 2;
		this.orbitControls.rotateSpeed = 1;
		this.orbitControls.zoomSpeed = 1;
		this.orbitControls.enableDamping = true;
		this.orbitControls.enableZoom = false;
		this.orbitControls.dampingFactor = 0.05;
		this.orbitControls.enablePan = true;
	}

	update() {
		this.orbitControls.update();
	}

	destroy() {
		this.orbitControls.destroy();
	}
}
